import { render, staticRenderFns } from "./daifankuizfb.vue?vue&type=template&id=5ced7952&scoped=true&"
import script from "./daifankuizfb.vue?vue&type=script&lang=js&"
export * from "./daifankuizfb.vue?vue&type=script&lang=js&"
import style0 from "./daifankuizfb.vue?vue&type=style&index=0&id=5ced7952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ced7952",
  null
  
)

export default component.exports